import * as actionTypes from 'redux/actions'

const initialState = {}

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACCOUNT_TYPE: {
      return {
        ...state,
        accountType: action.payload
      }
    }
    case actionTypes.SET_REG_NUM: {
      return {
        ...state,
        registrationNum: action.payload
      }
    }
    case actionTypes.SET_COM_NAME: {
      return {
        ...state,
        companyName: action.payload
      }
    }
    case actionTypes.SET_ADDRESS: {
      return {
        ...state,
        address: action.payload
      }
    }
    case actionTypes.SET_CONTACT: {
      return {
        ...state,
        contactPerson: action.payload
      }
    }
    case actionTypes.SET_CONTACT_EMAIL: {
      return {
        ...state,
        contactEmail: action.payload
      }
    }
    case actionTypes.SET_CONTRACT: {
      return {
        ...state,
        contract: action.payload
      }
    }
    case actionTypes.SET_ATTACHMENT: {
      return {
        ...state,
        attachment: action.payload
      }
    }
    case actionTypes.SET_FULL_NAME: {
      return {
        ...state,
        fullName: action.payload
      }
    }
    case actionTypes.SET_POSITION: {
      return {
        ...state,
        position: action.payload
      }
    }
    case actionTypes.SET_PHONE: {
      return {
        ...state,
        phoneNumber: action.payload
      }
    }
    case actionTypes.SET_EMAIL: {
      return {
        ...state,
        email: action.payload
      }
    }
    case actionTypes.SET_REFERRAL: {
      return {
        ...state,
        referral: action.payload
      }
    }
    case actionTypes.SET_FIRST_NAME: {
      return {
        ...state,
        firstName: action.payload
      }
    }
    case actionTypes.SET_LAST_NAME: {
      return {
        ...state,
        lastName: action.payload
      }
    }
    case actionTypes.RESET_ACCOUNT_FIELDS: {
      return {}
    }
    default: {
      return state
    }
  }
}

export default sessionReducer
